var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoNoAccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:#fff!important}.cls-5{fill:#f2f2f2!important}.cls-8{fill:#262626!important}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25551",
    "data-name": "Group 25551"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,62H126a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5H2a.5.5,0,0,1-.5-.5h0A.5.5,0,0,1,2,62Z",
    style: {
      fill: "#e6e6e6!important"
    },
    id: "Rectangle_11450",
    "data-name": "Rectangle 11450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,2.5h56a4.9,4.9,0,0,1,5,4.9V55.2a4.9,4.9,0,0,1-5,4.9h-56a4.9,4.9,0,0,1-5-4.9V7.4A4.9,4.9,0,0,1,22.5,2.5Z",
    style: {
      fill: "#f5f5f5!important"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,1h-56A6.5,6.5,0,0,0,16,7.4V55.2a6.4,6.4,0,0,0,6.5,6.3h56A6.4,6.4,0,0,0,85,55.2V7.4A6.5,6.5,0,0,0,78.5,1Zm0,59.1h-56a4.9,4.9,0,0,1-5-4.9V8.3h66V55.2A4.9,4.9,0,0,1,78.5,60.1ZM22.5,2.5h56a4.9,4.9,0,0,1,5,4.8h-66A4.9,4.9,0,0,1,22.5,2.5Z",
    style: {
      fill: "#dedede!important"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25548",
    "data-name": "Group 25548"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.5,23.5,111.6,41a2.8,2.8,0,0,1,1.5,3.8l-5.9,13.1a3.1,3.1,0,0,1-4,1.5L63.1,41.9a2.8,2.8,0,0,1-1.5-3.8l6-13.1A3,3,0,0,1,71.5,23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.2,29.1l5.3,2.3a2.2,2.2,0,0,1,1.1,2.9h0a2.3,2.3,0,0,1-3,1.1l-5.3-2.3a2.2,2.2,0,0,1-1.1-2.9h0A2.3,2.3,0,0,1,73.2,29.1Z",
    id: "Rectangle_11444",
    "data-name": "Rectangle 11444"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.1,35.8l7.8,3.4a2.2,2.2,0,0,1,1.2,2.9h0a2.3,2.3,0,0,1-3,1.2l-7.9-3.4a2.3,2.3,0,0,1-1.1-3h0A2.3,2.3,0,0,1,70.1,35.8Z",
    id: "Rectangle_11447",
    "data-name": "Rectangle 11447"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.2,35.2l19.1,8.3a2.2,2.2,0,0,1,1.1,2.9h0a2.3,2.3,0,0,1-3,1.1L85.3,39.2a2.2,2.2,0,0,1-1.1-2.9h0A2.3,2.3,0,0,1,87.2,35.2Z",
    id: "Rectangle_11445",
    "data-name": "Rectangle 11445"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.8,43.5l15.4,6.7a2.2,2.2,0,0,1,1.2,2.9h0a2.3,2.3,0,0,1-3,1.2L86,47.6a2.2,2.2,0,0,1-1.2-3h0A2.3,2.3,0,0,1,87.8,43.5Z",
    id: "Rectangle_11446",
    "data-name": "Rectangle 11446"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25549",
    "data-name": "Group 25549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11443-2",
    "data-name": "Rectangle 11443-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.7,42a4.5,4.5,0,0,0-2.4-2.5L104.4,36l-.9-5a4.5,4.5,0,0,0-5.2-3.6l-9.8,1.7-16.3-7a4.6,4.6,0,0,0-6.1,2.3l-4.3,9.3-2.5.5a4.5,4.5,0,0,0-3,1.8,4.6,4.6,0,0,0-.7,3.3l2.6,14A4.3,4.3,0,0,0,62.6,57h.8l21.5-3.7,17.6,7.6a4.3,4.3,0,0,0,1.9.4,4.7,4.7,0,0,0,4.3-2.7l5.9-13A4.3,4.3,0,0,0,114.7,42ZM98.5,28.9a3,3,0,0,1,3.5,2.4l.7,4L91,30.2Zm6,16.5a2.6,2.6,0,0,1-.4,2.1,2.8,2.8,0,0,1-2,1.2L85.4,51.6,63.1,41.9a3.1,3.1,0,0,1-1.6-1.6,3.3,3.3,0,0,1,.1-2.2L63,35l25-4.3,15.1,6.6ZM67.6,25a2.9,2.9,0,0,1,2.7-1.7l1.2.2,14.1,6.1L63.8,33.4ZM63.1,55.4a3,3,0,0,1-3.5-2.3L57.1,39a2.9,2.9,0,0,1,.5-2.2,3.1,3.1,0,0,1,1.9-1.2l1.5-.2-.9,2a4.4,4.4,0,0,0,2.4,6l19.9,8.7Zm50-10.6-5.9,13.1a3.1,3.1,0,0,1-4,1.5L87.9,52.7l14.5-2.5a4.7,4.7,0,0,0,2.9-1.8,4.4,4.4,0,0,0,.7-3.3L104.7,38l6.9,3a3.1,3.1,0,0,1,1.6,1.6A2.8,2.8,0,0,1,113.1,44.8Z",
    style: {
      fill: "#ccc!important"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.5,35.6l39-6.7a3,3,0,0,1,3.5,2.4l2.5,14a2.9,2.9,0,0,1-2.4,3.4l-39,6.8a3.1,3.1,0,0,1-3.5-2.4L57.1,39A2.9,2.9,0,0,1,59.5,35.6Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,39.3l5.7-1a2.3,2.3,0,0,1,2.7,1.8h0a2.3,2.3,0,0,1-1.9,2.6l-5.7,1a2.3,2.3,0,0,1-2.6-1.8h0A2.3,2.3,0,0,1,64,39.3Z",
    id: "Rectangle_11444-2",
    "data-name": "Rectangle 11444-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.4,46.6l8.4-1.5a2.3,2.3,0,0,1,2.6,1.8h0a2.3,2.3,0,0,1-1.8,2.6l-8.5,1.4a2.2,2.2,0,0,1-2.6-1.8h0A2.2,2.2,0,0,1,65.4,46.6Z",
    id: "Rectangle_11447-2",
    "data-name": "Rectangle 11447-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77,37.1l18.6-3.2a2.3,2.3,0,0,1,2.6,1.8h0a2.3,2.3,0,0,1-1.8,2.6L77.8,41.5a2.2,2.2,0,0,1-2.6-1.8h0A2.2,2.2,0,0,1,77,37.1Z",
    id: "Rectangle_11445-2",
    "data-name": "Rectangle 11445-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.3,43.7l14.6-2.5a2.1,2.1,0,0,1,2.6,1.7h0a2.2,2.2,0,0,1-1.8,2.5L83.1,48a2.3,2.3,0,0,1-2.7-1.8h0A2.2,2.2,0,0,1,82.3,43.7Z",
    id: "Rectangle_11446-2",
    "data-name": "Rectangle 11446-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cross"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5,53.3l3.7-1.7a.5.5,0,0,0,.3-.7h0L91.1,48a.5.5,0,0,0-.7-.3h0l-3.7,1.7-1.8-3.6a.5.5,0,0,0-.7-.3h0l-3,1.4a.4.4,0,0,0-.2.7h0l1.7,3.6L79,52.9a.5.5,0,0,0-.3.7h0l1.4,2.9a.5.5,0,0,0,.7.3h0l3.7-1.7,1.8,3.6a.5.5,0,0,0,.7.3h0l3-1.4a.5.5,0,0,0,.2-.7h0Z",
    style: {
      fill: "#fe7b7c!important"
    },
    id: "Path_46278",
    "data-name": "Path 46278"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M86.5,59.2a.8.8,0,0,1-.4-.4l-.7-1.4c0-.1,0-.2.1-.2a.2.2,0,0,1,.3.1l.7,1.3c0,.2.2.3.4.2l3-1.4c.2,0,.2-.2.1-.4l-1.7-3.6c0-.1,0-.3.1-.3h0l3.7-1.7c.2-.1.3-.3.2-.4l-1.4-2.9c-.1-.2-.3-.3-.4-.2l-3.8,1.7c-.1,0-.2,0-.2-.1h0l-1-2a.2.2,0,0,1,.1-.3c.1-.1.2,0,.3.1h0l.9,1.8,3.5-1.6a.8.8,0,0,1,1,.4l1.4,2.9a.7.7,0,0,1-.4,1l-3.5,1.6,1.6,3.4a.8.8,0,0,1-.3,1l-3,1.4Z",
    id: "Path_46279",
    "data-name": "Path 46279"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M80.3,57a.8.8,0,0,1-.4-.4l-1.4-2.9a.7.7,0,0,1,.4-1l3.5-1.6-1.6-3.4a.7.7,0,0,1,.3-1l3-1.4a.8.8,0,0,1,1,.4l.4.8a.2.2,0,0,1-.1.3c-.1.1-.2,0-.3-.1h0l-.4-.8c0-.2-.2-.3-.4-.2l-3,1.4c-.2,0-.2.2-.2.4l1.8,3.6c0,.1,0,.3-.1.3h0l-3.7,1.7c-.2.1-.3.3-.2.4l1.4,2.9c.1.2.3.3.4.2l3.7-1.7c.2,0,.3,0,.3.1h0l.7,1.5c.1.1.1.2-.1.3h-.2l-.7-1.3L80.9,57A.6.6,0,0,1,80.3,57Z",
    id: "Path_46280",
    "data-name": "Path 46280"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoNoAccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_no_access.f762e4faf1ecc2483773e3ec0a7b78cb.svg";